import { HttpMethods, RestRequest, RestResponse } from '@maverick/http';
import { cateringClient, createApiClient, orderClient } from './client';
import { SourceApps } from '@maverick/entity';

const apiVersion = 'v1.1';

interface RetrieveUserRecentOrdersParams {
    authtoken: string;
}

interface RetrieveUserFavesParams {
    authtoken: string;
}

interface AuthorizeUserParams {
    provider: string;
    providertoken: string;
    provideruserid: string;
    contactnumber: string | null;
    orderBasketid: string | null;
    cateringBasketid: string | null;
    firstname: string | null;
    lastname: string | null;
    emailaddress: string | null;
}

interface GetQualifyingRewards {
    authtoken: string | null;
    vendorId: number | null;
}

export class UserService {
    private readonly apiClient;

    constructor(sourceApp: SourceApps) {
        this.apiClient = createApiClient(sourceApp);
    }

    async retrieveUserRecentOrders(params: RetrieveUserRecentOrdersParams): Promise<RestResponse> {
        const { authtoken } = params;
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `${apiVersion}/users/${authtoken}/recentorders`,
        });

        return this.apiClient.ExecuteRequest(request);
    }

    async retrieveUserFaves(params: RetrieveUserFavesParams): Promise<RestResponse> {
        const { authtoken } = params;
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `${apiVersion}/users/${authtoken}/faves`,
        });

        return this.apiClient.ExecuteRequest(request);
    }

    async authorizeUser(
        params: AuthorizeUserParams
    ): Promise<{ responseOrder: RestResponse; responseCatering: RestResponse }> {
        const createUserRequest = (basketid: string | null) => {
            return new RestRequest({
                method: HttpMethods.Post,
                endpoint: `${apiVersion}/users/getorcreate`,
                body: {
                    provider: params.provider,
                    providertoken: params.providertoken,
                    provideruserid: params.provideruserid,
                    contactnumber: params.contactnumber,
                    basketid: basketid,
                    firstname: params.firstname,
                    lastname: params.lastname,
                    emailaddress: params.emailaddress,
                },
                retry: true,
            });
        };

        const [responseOrder, responseCatering] = await Promise.all([
            orderClient.ExecuteRequest(createUserRequest(params.orderBasketid)),
            cateringClient.ExecuteRequest(createUserRequest(params.cateringBasketid)),
        ]);

        return { responseOrder, responseCatering };
    }

    async getQualifyingRewards(params: GetQualifyingRewards): Promise<RestResponse> {
        const request = new RestRequest({
            method: HttpMethods.Get,
            endpoint: `${apiVersion}/users/${params.authtoken}/qualifyingrewards?vendorId=${params.vendorId}`,
        });

        return this.apiClient.ExecuteRequest(request);
    }
}
